import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=e8e1d2f8&"
import script from "./LearningResources.vue?vue&type=script&lang=js&"
export * from "./LearningResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports